import { combineReducers } from 'redux';

import calculationResults from './calculation-results';
import fieldPoints from './field-points';

export default combineReducers({
    calculationResults,
    fieldPoints
});
